module.exports = __webpack_public_path__ + "0421cae97d663331048e0c2177821982.woff";